export default {
  common: {
    home: 'Главная',
    loading: 'Загрузка...',
    allNews: 'Все новости',
    goToSite: 'Перейти на сайт',
    language: 'Язык',
    menu: 'Меню',
    notFound: 'Статья не найдена.',
    backToList: 'Вернуться к списку',
    // The header/footer lock-up may wrap ONLY at the three ordinary spaces
    // below, because the value is interpolated as plain text and cannot carry
    // markup. \u2060 (word joiner) keeps "научно-методический" whole across its hyphen;
    // \u00A0 (non-breaking space) binds the last two word groups. In the 240px
    // header column that yields four lines:
    //   Республиканский / научно-методический /
    //   центр развития образования / Республики Узбекистан
    orgName:
      'Республиканский научно-\u2060методический ' +
      'центр\u00A0развития\u00A0образования ' +
      'Республики\u00A0Узбекистан',
    testMode: 'Сайт работает в тестовом режиме',
    newsNotFound: 'Новость не найдена.',
    gerbAlt: 'Герб Республики Узбекистан',
    views: 'Просмотры',
    soon: 'Скоро'
  },

  nav: {
    markaz: 'Центр',
    faoliyat: 'Деятельность',
    hujjatlar: 'Документы',
    axborot: 'Информационная служба',
    pisa: 'PISA',
    boglanish: 'Контакты',

    markazHaqida: 'О центре',
    rahbariyat: 'Руководство',
    boshqarmaBoshliqlari: 'Начальники управлений',
    tuzilma: 'Структура',

    oquvMetodik: 'Учебно-нормативная и методическая координация образования',
    baholashMonitoring: 'Оценка и мониторинг качества образования',
    raqamliSavodxonlik: 'Внедрение цифровой грамотности и инновационных технологий',
    talimNormativlari: 'Педагогико-психологическая поддержка образования',
    hisobotlar: 'Отчёты',

    prezidentFarmonlari: 'Указы, распоряжения\nи постановления Президента',
    talimgaOidQonunlar: 'Законы об образовании',
    vazirlarMahkamasi: 'Постановления Кабинета Министров',
    markazFaoliyati: 'Документы о деятельности центра',
    talimgaDoirHujjatlar: 'Документы об образовании',

    yoshOlimlar: 'Школа молодых учёных и исследователей',
    savolJavob: 'Вопросы и ответы',
    ochiqMalumotlar: 'Открытые данные',
    yangiliklar: 'Новости',
    galereya: 'Галерея',
    ilmiyMaqolalar: 'Научные статьи',

    ilmiyMetodik: 'Научно-методическая деятельность и международное сотрудничество',
    ilmiyMetodikFaoliyat: 'Научно-методическая деятельность',
    xalqaroHamkorlik: 'Международное сотрудничество',
    ilmiyLoyihalar: 'Научно-исследовательские проекты'
  },

  footer: {
    copyright: '© 2026. При полном или частичном использовании материалов ссылка на источник trm.uz обязательна.',
    callAria: 'Позвонить: {phone}',
    emailAria: 'Написать на email: {email}'
  },

  a11y: {
    title: 'Специальные возможности',
    close: 'Закрыть',
    fontSize: 'Размер шрифта:',
    zoom: 'Масштаб:',
    screenReader: 'Экранный диктор:',
    toggle: 'Вкл / Выкл',
    maleVoice: 'Мужской голос',
    femaleVoice: 'Женский голос',
    readerHint: 'Когда включено, нажмите на текст, который нужно озвучить.',
    googleTranslate: 'Google переводчик:',
    selectLanguage: 'Выберите язык',
    readingMode: 'Режим чтения',
    reset: 'Сбросить настройки',
    modeDefault: 'Обычный',
    modeInvert: 'Инвертировать цвета',
    modeContrast: 'Контраст',
    modeGray: 'Оттенки серого'
  },

  pager: {
    label: 'Страницы',
    first: 'Первая страница',
    prev: 'Предыдущая страница',
    next: 'Следующая страница',
    last: 'Последняя страница'
  },

  lightbox: {
    prev: 'Предыдущая',
    next: 'Следующая'
  },

  home: {
    heroTitle: 'На пути совершенствования качества образования',
    heroSubtitle: 'Центр, осуществляющий деятельность по развитию содержания, методики образования и мониторинга качества',

    featureOquvMetodik: 'Учебно-нормативная и методическая координация образования',
    featureBaholash: 'Оценка и мониторинг качества образования',
    featureNormativlar: 'Педагогико-психологическая поддержка образования',
    featureRaqamli: 'Внедрение цифровой грамотности и инновационных технологий',

    newsTitle: 'Новости и объявления',

    prezidentQuote: 'И фундамент прогресса, и сила, делающая страну могущественной, а нацию — великой, — это наука, образование и воспитание.',
    prezidentName: 'Шавкат Мирзиёев',
    prezidentRole: 'Президент Республики Узбекистан',

    statMaktabgacha: 'Организации дошкольного образования',
    statUmumiy: 'Организации общего среднего образования',
    statKasbiy: 'Организации среднего специального и профессионального образования',
    statOliy: 'Организации высшего образования',

    mediaTitle: 'Медиа',
    mediaPhotos: 'Фотографии',
    mediaVideos: 'Видео',
    mediaNoVideos: 'Видео пока отсутствуют.',
    mediaNoPhotos: 'Фотографии пока отсутствуют.',
    mediaPlay: 'Воспроизвести видео',

    portalTitle: 'Единый портал цифровых образовательных ресурсов и услуг',
    portalSubtitle: 'Экосистема методической поддержки в образовании',

    linksTitle: 'Полезные ссылки',
    linkIma: 'Агентство специализированных образовательных учреждений',
    linkGov: 'Правительственный портал Республики Узбекистан',
    linkUzedu: 'Министерство дошкольного и школьного образования',
    linkOliy: 'Министерство высшего образования, науки и инноваций'
  },

  pages: {
    comingSoon: {
      title: 'Скоро',
      text: 'Раздел находится в разработке. Материалы будут опубликованы в ближайшее время.'
    },

    hisobotlar: {
      intro: 'Квартальные, полугодовые и годовые отчёты о деятельности Центра.',
      typeFilter: 'Тип отчёта',
      yearFilter: 'Год',
      all: 'Все',
      quarterly: 'Квартальные',
      halfYear: 'Полугодовые',
      annual: 'Годовые',
      allYears: 'Все годы',
      periods: { q1: 'I квартал', q2: 'II квартал', q3: 'III квартал', q4: 'IV квартал', h1: 'I полугодие', h2: 'II полугодие', year: 'Годовой' },
      yearLabel: '{year} год',
      empty: 'Отчёты пока не опубликованы.',
      noMatch: 'За выбранный период отчётов не найдено.',
      resetFilters: 'Сбросить фильтры',
      download: 'Скачать отчёт',
      attachment: 'Приложение',
      notFound: 'Отчёт не найден.',
      others: 'Другие отчёты',
      kpiTotal: 'Всего отчётов',
      kpiPublished: 'Опубликовано',
      kpiPending: 'Ожидается',
      progress: 'Кварталы {year} года',
      legendDone: 'Опубликован',
      legendNow: 'Текущий квартал',
      legendWait: 'Ожидается',
      search: 'Поиск по отчётам',
      preparing: 'Готовится',
      downloadShort: 'Скачать',
      more: 'Подробнее',
      count: 'Отчётов: {n}',
      range: '{from} — {to} {year}',
      months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
    },

    ochiqMalumotlar: {
      openFile: 'открыть файл'
    },

    oquvMetodik: {
      figAlt1: 'Учебно-методические комплексы — выполненные работы (1)',
      figAlt2: 'Учебно-методические комплексы — выполненные работы (2)',
      blocks: [
        { type: 'lead', text: 'Управление учебно-нормативной и методической координации образования' },
        { type: 'label', text: 'В составе управления имеются следующие отделы:' },
        { type: 'list', items: [
          'Отдел внедрения образовательных программ и учебно-методических комплексов',
          'Отдел экспертно-аналитических услуг'
        ] },
        { type: 'section', text: 'Задачи и функции управления' },
        { type: 'list', items: [
          'координация процессов разработки, анализа и внедрения учебно-нормативных документов, учебных планов и программ, учебно-методических комплексов в сфере образования, а также обеспечение их применения на практике;',
          'разработка требований к образовательным стандартам, учебным планам и программам дошкольных, общих средних и внешкольных образовательных организаций, а также краткосрочных, в том числе частных учебных курсов;',
          'совершенствование методики преподавания в дошкольных, общих средних и внешкольных образовательных организациях, издание новых учебно-методических комплексов на основе современных требований и передового зарубежного опыта, координация их внедрения в практику;',
          'организация системной научно-методической работы по апробации и научной экспертизе учебно-методических комплексов, анализу полученных результатов и их совершенствованию;',
          'развитие экспертно-аналитической деятельности в сфере образования, подготовка экспертных заключений по учебным программам, методическим пособиям, учебникам и другой учебно-методической продукции, а также разработка научно обоснованных методических рекомендаций;',
          'координация деятельности Научно-методических советов по направлениям науки, созданных при Центре;',
          'проведение аналитических и прикладных исследований, направленных на развитие сферы образования, подготовка научных разработок и рекомендаций по широкому использованию достижений мировой науки и технологий в образовательном процессе;',
          'реализация научно-практических инициатив по совершенствованию содержания образования в сотрудничестве с международными организациями, научными центрами и передовыми зарубежными издательствами, обеспечение изучения передового зарубежного опыта и его адаптации к местной практике.'
        ] }
      ]
    },

    markazHaqida: {
      title: 'РЕСПУБЛИКАНСКИЙ НАУЧНО-МЕТОДИЧЕСКИЙ ЦЕНТР РАЗВИТИЯ ОБРАЗОВАНИЯ',
      tasksTitle: 'ОСНОВНЫЕ ЗАДАЧИ ЦЕНТРА:',
      tasks: [
        'внедрение в образовательный процесс инновационных педагогических технологий, эффективных форм и методов обучения, современных систем оценки и мониторинга качества образования;',
        'разработка и утверждение требований к образовательным стандартам, учебным планам и программам дошкольных, общих средних и внешкольных образовательных организаций, а также краткосрочных, в том числе частных учебных курсов (далее — учебные курсы);',
        'совершенствование методики преподавания в образовательных организациях, издание новых учебников и учебно-методических комплексов на основе современных требований и передового зарубежного опыта, организация их апробации и экспертизы;',
        'внедрение передовых форм подготовки, переподготовки и повышения квалификации руководящих и педагогических кадров образовательных организаций, создание условий для непрерывного повышения профессионального мастерства учителей;',
        'участие в мониторинге качества учебно-воспитательного процесса и подготовки кадров в образовательных организациях, анализе соответствия знаний обучающихся образовательным стандартам и требованиям, организация проведения международных программ и исследований в области качества образования в Республике Узбекистан;',
        'проведение аналитических и прикладных исследований, направленных на развитие сферы образования, подготовка научных разработок и рекомендаций по широкому использованию достижений мировой науки и технологий в образовательном процессе;',
        'изучение и системный анализ передовой практики в сфере образования, принятие комплекса мер по её внедрению в республике, развитие связей с ведущими зарубежными научно-исследовательскими организациями.',
        'требования к образовательным стандартам, учебным планам и программам, разработанные и утверждённые республиканским центром, являются обязательными для дошкольных, общих средних и внешкольных образовательных организаций, а также учебных курсов;'
      ]
    },

    tuzilma: {
      heading: 'Структура Республиканского научно-методического центра развития образования',
      annex: 'ПРИЛОЖЕНИЕ к постановлению Президента Республики Узбекистан № ПП-128 от 20 апреля 2023 года',
      staff: 'Общая численность сотрудников — 42 человека, в том числе управленческий персонал — 15 человек, научные сотрудники — 27 человек.',
      revision: '(текст приложения в редакции Указа Президента Республики Узбекистан от 29 октября 2025 года № УП-197)',
      director: 'Директор',
      advisors: 'Советники',
      deputy: 'Заместитель директора',
      board1: 'Управление учебно-нормативной и методической координации образования',
      b1u1: 'Отдел внедрения образовательных программ и учебно-методических комплексов',
      b1u2: 'Отдел экспертно-аналитических услуг',
      board2: 'Управление педагогико-психологической поддержки образования',
      b2u1: 'Отдел развития педагогического мастерства и инклюзивного образования',
      b2u2: 'Отдел развития психологической службы и профориентации',
      board3: 'Управление оценки и мониторинга качества образования',
      b3u1: 'Отдел оценки и социально-прикладных исследований',
      b3u2: 'Отдел анализа показателей в международных программах и рейтингах',
      board4: 'Управление внедрения цифровой грамотности и инновационных технологий',
      b4u1: 'Отдел развития цифровой педагогики и медиаобразования',
      b4u2: 'Отдел внедрения цифровых технологий и инноваций',
      s1: 'Информационная служба',
      s2: 'Отдел бухгалтерского учёта',
      s3: 'Отдел координации научно-методической деятельности и международного сотрудничества',
      s4: 'Служба развития человеческих ресурсов',
      s5: 'Служба исполнительской дисциплины и работы с обращениями',
      s6: 'Юрисконсульт',
      s7: 'Главный специалист по ИКТ'
    },

    contact: {
      title: 'Если у вас есть любой вопрос или предложение, вы можете написать нам',
      address: 'г. Ташкент, улица Навои, дом 30',
      mapTitle: 'Расположение центра',
      formTitle: 'Отправить сообщение',
      name: 'Ваше имя',
      phone: 'Ваш номер телефона',
      email: 'Электронная почта',
      subject: 'Тема',
      choose: 'Выберите',
      message: 'Сообщение',
      send: 'Отправить',
      sending: 'Отправка...',
      sent: 'Ваше сообщение отправлено. Мы скоро ответим.',
      topicGeneral: 'Общий вопрос',
      topicSuggestion: 'Предложение',
      topicComplaint: 'Жалоба',
      topicCooperation: 'Сотрудничество',
      errName: 'Введите ваше имя.',
      errMessage: 'Текст сообщения должен содержать не менее 5 символов.',
      errPhone: 'Введите номер телефона полностью (+998 и 9 цифр).',
      errSend: 'Не удалось отправить сообщение. Проверьте интернет и попробуйте снова.'
    },

    ilmiy: {
      head: 'Список научных работ, опубликованных сотрудниками Республиканского научно-методического центра развития образования',
      colNo: '№',
      colName: 'Ф.И.О.',
      colTopic: 'Тема научной работы',
      colUrl: 'URL-адрес (ссылка)',
      goToLink: 'Перейти по ссылке',
      noLink: 'Нет ссылки',
      filterAll: 'Все',
      filterInternational: 'Международные',
      filterLocal: 'Местные',
      filterScopus: 'Scopus / WoS',
      filterNew: 'Недавно добавленные',
      badgeNew: 'Новое',
      emptyList: 'Данные не найдены'
    },

    baholash: {
      blocks: [
        { type: 'lead', text: 'Управление оценки и мониторинга качества образования' },
        { type: 'label', text: 'В составе управления имеются следующие отделы:' },
        { type: 'list', items: [
          'Отдел оценки и социально-прикладных исследований',
          'Отдел анализа показателей в международных программах и рейтингах'
        ] },
        { type: 'section', text: 'Задачи и функции управления' },
        { type: 'list', items: [
          'выявление факторов, влияющих на качество образования, и проверка исполнения государственных образовательных стандартов в дошкольных, общих средних и внешкольных образовательных организациях, а также осуществление системного мониторинга;',
          'координация процессов лицензирования, аттестации и государственной аккредитации дошкольных, общих средних и внешкольных образовательных организаций, а также учебных курсов;',
          'мониторинг качества учебно-воспитательного процесса и подготовки кадров в образовательных организациях, анализ соответствия знаний учащихся стандартам и внедрение современных систем оценки;',
          'сбор системных данных, проведение социально-прикладных исследований и подготовка научно обоснованных предложений для принятия основанных на доказательствах решений в сфере образования;',
          'регулярный анализ эффективности образовательных стандартов, учебных планов, программ и учебников, а также разработка рекомендаций по их совершенствованию;',
          'обеспечение участия в международных программах и исследованиях по оценке образовательных достижений учащихся (PISA, PIRLS, TIMSS, TALIS) и содействие улучшению показателей в рейтингах;',
          'налаживание сотрудничества с международными организациями, университетами и научными центрами, повышение квалификации учителей на основе результатов исследований и внедрение передовой международной практики бенчмаркинга;',
          'широкая популяризация результатов международного и национального оценивания в средствах массовой информации и социальных сетях, подготовка и публикация научных статей по деятельности сферы;',
          'участие в разработке критериев оценки деятельности образовательных организаций в сотрудничестве с уполномоченными органами.'
        ] }
      ]
    },

    raqamli: {
      blocks: [
        { type: 'lead', text: 'Управление внедрения цифровой грамотности и инновационных технологий' },
        { type: 'label', text: 'В составе управления имеются следующие отделы:' },
        { type: 'list', items: [
          'Отдел развития цифровой педагогики и медиаобразования',
          'Отдел внедрения цифровых технологий и инноваций'
        ] },
        { type: 'section', text: 'Задачи и функции управления' },
        { type: 'list', items: [
          'разработка и внедрение программ, проектов, методических материалов и учебно-методических комплексов, направленных на повышение цифровой грамотности в системе образования, а также на развитие цифровых компетенций и навыков участников образовательного процесса;',
          'интеграция цифровой педагогики, медиаобразования и современных технологий обучения в образовательный процесс, изучение передового зарубежного опыта в этой сфере и его адаптация к местным условиям;',
          'разработка методических рекомендаций, учебно-методических пособий и инструкций по этике использования технологий искусственного интеллекта в образовательном процессе, обеспечению конфиденциальности данных и информационной безопасности;',
          'формирование системы использования в образовательном процессе виртуальной и дополненной реальности (VR/AR), симуляторов, интерактивных платформ и других инновационных цифровых технологий, а также реализация опытно-экспериментальных проектов по оценке их эффективности;',
          'создание цифрового учебного контента (видеоуроков, интерактивных занятий, мультимедийных ресурсов, учебных платформ) для организаций дошкольного и школьного образования, содействие проведению его методической и технической экспертизы качества;',
          'внедрение инновационных решений и механизмов цифрового управления в деятельность образовательных учреждений, оказание научно-методической поддержки по автоматизации процессов и подготовка аналитических заключений;',
          'проведение научно-методических исследований по внедрению цифровых образовательных платформ, баз данных и систем управления учебным процессом (LMS, LXP, LRS), а также по обеспечению их бесперебойной и эффективной работы;',
          'разработка методических и организационных решений по внедрению в образование EdTech, электронных учебных ресурсов, виртуальных лабораторий и симуляторов, оценка и совершенствование применяемых технологий;',
          'подготовка контента, учебно-методических комплексов и методических материалов для краткосрочных курсов повышения квалификации, тренингов и вебинаров по развитию цифровых компетенций педагогов;',
          'проведение аналитических и научно-практических исследований в области цифрового образования, медиаобразования и инноваций, выработка на основе результатов исследований стратегических предложений и рекомендаций по развитию сферы;',
          'реализация совместных программ и международных грантовых проектов по внедрению цифрового образования и инновационных технологий в сотрудничестве с международными организациями, донорами и технологическими компаниями, координация соответствующих инициатив.'
        ] }
      ]
    },

    normativ: {
      blocks: [
        { type: 'lead', text: 'Управление педагогико-психологической поддержки образования' },
        { type: 'label', text: 'В составе управления имеются следующие отделы:' },
        { type: 'list', items: [
          'Отдел развития педагогического мастерства и инклюзивного образования',
          'Отдел развития психологической службы и профориентации'
        ] },
        { type: 'section', text: 'Задачи и функции управления' },
        { type: 'list', items: [
          'научно-методическое обеспечение педагогической и психологической поддержки в системе дошкольного, общего среднего и внешкольного образования, поддержка профессионального развития педагогических и психологических кадров, совершенствование системы инклюзивного образования и профориентации;',
          'изучение передового национального и международного опыта, внедрение современных подходов, а также подготовка научно-методических разработок, служащих формированию безопасной, инклюзивной и развивающей образовательной среды для участников образовательного процесса;',
          'совершенствование системы педагогической и психологической поддержки образования, профессионального развития кадров на основе передового опыта и исследований;',
          'внедрение инновационных парадигм и методик в учебно-воспитательный процесс, формирование идеологического иммунитета у участников образовательного процесса, совершенствование механизмов создания инклюзивной, психологически устойчивой и развивающей образовательной среды;',
          'определение требований к деятельности педагогических кадров, их профессиональное развитие, внедрение ценностной и идеологической практики, основанной на идеях гуманизма, устойчивого развития личности и социального партнёрства, инклюзивности, а также эффективных образовательных стратегий;',
          'координация деятельности психологов, их профессиональное развитие, внедрение современной практики и технологий, передового опыта, методическая поддержка создания в образовании среды психологического благополучия, доверия и развития;',
          'подготовка научных разработок и рекомендаций по широкому использованию достижений мировой науки и технологий в образовательном процессе;',
          'стратегическая поддержка непрерывного образования и системная реализация профориентации, формирование устойчивых навыков обучения на протяжении всей жизни, разработка и внедрение моделей и программ профориентации, индивидуальных образовательных и карьерных траекторий в соответствии с реальными требованиями рынка труда.'
        ] }
      ]
    }
  }
}
